module.exports = __webpack_public_path__ + "img/imgloading.b39f8b55.gif";